import { render, staticRenderFns } from "./ThumbnailWrap.vue?vue&type=template&id=2dbe814d&scoped=true&"
import script from "./ThumbnailWrap.vue?vue&type=script&lang=js&"
export * from "./ThumbnailWrap.vue?vue&type=script&lang=js&"
import style0 from "./ThumbnailWrap.vue?vue&type=style&index=0&id=2dbe814d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dbe814d",
  null
  
)

export default component.exports